<!-- PaymentFoundModal.vue -->
<template>
  <div class="modal fade" id="paymentFoundModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-light">
          <h5 class="modal-title">
            <span v-if="pendingPayment && pendingPayment.paymentDetails.length > 1">
              Multiple Payments Found
            </span>
            <span v-else>Payment Found</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body" v-if="pendingPayment">
          <div class="alert alert-info" role="alert">
            <i class="bx bx-info-circle me-2"></i>
            <span v-if="pendingPayment.paymentDetails.length > 1">
              Multiple payments have been found for this bill that need to be processed.
            </span>
            <span v-else>
              A payment has been found for this bill that needs to be processed.
            </span>
          </div>

          <!-- Bill Details -->
          <div class="mt-4">
            <h6>Bill Details:</h6>
            <table class="table table-sm table-bordered">
              <tr>
                <th style="width: 30%;">Bill Number</th>
                <td>{{ pendingPayment.billItem.billNo }}</td>
              </tr>
              <tr>
                <th>Customer</th>
                <td>{{ pendingPayment.billItem.customerName }}</td>
              </tr>
              <tr>
                <th>Amount</th>
                <td>{{ formatPrice(pendingPayment.billItem.detailAmount) }}</td>
              </tr>
              <tr>
                <th>Balance</th>
                <td>{{ formatPrice(pendingPayment.billItem.billBalance) }}</td>
              </tr>
            </table>
          </div>

          <!-- Payment Details -->
          <div class="mt-4">
            <h6 v-if="pendingPayment.paymentDetails.length > 1">
              Payment Details ({{ pendingPayment.paymentDetails.length }} payments):
            </h6>
            <h6 v-else>Payment Details:</h6>

            <div class="table-responsive">
              <table class="table table-sm table-bordered table-striped">
                <thead class="table-light">
                <tr>
                  <th>#</th>
                  <th>Payment Method</th>
                  <th>Reference</th>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Paid By</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(payment, index) in pendingPayment.paymentDetails" :key="payment.id || index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <span class="badge bg-primary">{{ payment.source }}</span>
                  </td>
                  <td>
                    <code>{{ payment.account_ref || payment.transaction_code }}</code>
                  </td>
                  <td class="fw-semibold">{{ formatPrice(payment.amount) }}</td>
                  <td>{{ formatDate(payment.date) }}</td>
                  <td>{{ payment.names || payment.paidBy }}</td>
                  <td>
                    <button
                        type="button"
                        class="btn btn-sm btn-success"
                        @click="processPayment(payment)"
                        :disabled="processingPayment === payment.id"
                    >
                      <span v-if="processingPayment !== payment.id">Process</span>
                      <span v-else class="d-flex align-items-center">
                          <div class="spinner-border spinner-border-sm me-1" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          Processing...
                        </span>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentFoundModal",
  props: {
    pendingPayment: {
      type: Object,
      default: null
    },
    processingPayment: {
      type: [String, Number, Boolean],
      default: false
    }
  },
  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value || 0);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      try {
        return new Date(dateString).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    },

    processPayment(payment) {
      this.$emit('process-payment', payment);
    }
  }
}
</script>

<style scoped>
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}

.badge {
  font-size: 0.75rem;
}

code {
  font-size: 0.875rem;
  color: #6f42c1;
  background-color: #f8f9fa;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}
</style>